import { ContentItem } from '@deltek/specification-client/core/Models/contentItem'
import { TrackChangeType } from './changes'

export interface SetProjectContentItemElementsInput {
    contentItemId: string
    contentItemOwnerId: string
    contentItemOwnerType: string
    elements: Partial<TextContentElementInput>[]
    projectId: string
    nodeId: string
    projectProductFamilyId: string
    textType: string
    partType: string
    documentTemplateViewId: string
    documentTemplateViewItemId: string
    propertyKey: string
    contentItemParentType: string
    contentItemParentId: string
    parentOptionGroupId?: string
    updateType?: string
    specifierNotes?: string[]
    isDeletingBaseContent?: boolean
    isFromStudioManagementModule?: boolean
    isMasterSpecCloneNode?: boolean
    iterationId?: string
    selectedPillElementId?: string
}

export interface ChangeIndices {
    startIndex: number
    endIndex: number
    changeType: TrackChangeType
}

export interface TextContentElementInput {
    elements?: Partial<TextContentElementInput>[]
    hyperlinkUrl?: string
    id?: string
    imperialUnits?: string
    metricUnits?: string
    optionItemState?: string | null
    text?: string
    type?: string
    placeholderText?: string | null
    isListingActivatedOption?: boolean
    changeIndices?: ChangeIndices[]
    editedChars?: string[]
    isBestPractice?: boolean
    isGlobalBestPractice?: boolean
    parentOptionGroupId?: string
}

export interface SetProjectContentItemElementsResponse {
    setProjectContentItemElements: Partial<ContentItem>
}

// TODO: move this to @deltek\specification-client\core\Models\textContentElement.d.ts
// OR.. specpoint_api can provide this as a constant
export const TextContentElementType = {
    Text: 'Text',
    OptionGroup: 'OptionGroup',
    SelectionOption: 'SelectionOption',
    ReplacementOption: 'ReplacementOption',
    UnitsOfMeasure: 'UnitsOfMeasure',
    Hyperlink: 'Hyperlink',
    SectionName: 'SectionName',
    SectionNumber: 'SectionNumber',
    FieldRef: 'FieldRef',
    CustomImportedManufacturer: 'CustomImportedManufacturer',
} as const
